export const capitalize = s => {
    if (!s) return '';

    if (typeof s !== 'string') throw `cannot perform capitalize on type ${typeof s}`;

    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const toSnakecase = string =>
    string.replace(/\.?([A-Z])/g, (x, y) => {
        return `_${y.toLowerCase()}`;
    });

export const toCamelCase = string => string.replace(/(_\w)/g, m => m[1].toUpperCase());

// Some display names are HTML-escaped on write by the backend, so a single level of entities must be
// decoded before rendering them as text.
// Ampersands are decoded last so nested entities survive.
const HTML_ENTITY_DECODE_ORDER = [
    ['&lt;', '<'],
    ['&gt;', '>'],
    ['&quot;', '"'],
    ['&#x27;', "'"],
    ['&#39;', "'"],
    ['&amp;', '&'],
];

export const decodeHtmlEntities = value =>
    typeof value === 'string'
        ? HTML_ENTITY_DECODE_ORDER.reduce((decoded, [entity, char]) => decoded.split(entity).join(char), value)
        : value;
